var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share"},[_c('div',{staticClass:"share-top"},[_c('img',{attrs:{"src":_vm.icon}}),_c('div',[_c('p',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.type))])])]),(_vm.roundTitle)?_c('div',{staticClass:"round"},[_vm._v(_vm._s(_vm.roundTitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }